import React from 'react';
import FundingList from '../components/funding/FundingList';

const FundingListPage = () => {
  return <FundingList />;
};

export default FundingListPage;